import React from 'react';
import { cn } from '@/lib/utils';
import { CheckCircle, AlertTriangle } from 'lucide-react';
import { Progress } from '@/components/ui/progress';

const frameworkLabels = {
  lgpd: 'LGPD',
  iso27001: 'ISO 27001',
  nist: 'NIST CSF',
  cis: 'CIS Controls',
  'pci-dss': 'PCI-DSS',
};

export function ComplianceStatus({ compliance = [] }) {
  return (
    <div className="space-y-4" data-testid="compliance-status">
      <h3 className="font-display text-sm uppercase tracking-wider text-muted-foreground">
        Compliance
      </h3>
      
      <div className="space-y-3">
        {compliance.map((item) => {
          const label = frameworkLabels[item.framework] || item.framework.toUpperCase();
          const isCompliant = item.score >= 80;
          
          return (
            <div key={item.id} className="space-y-2">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  {isCompliant ? (
                    <CheckCircle className="h-4 w-4 text-success" />
                  ) : (
                    <AlertTriangle className="h-4 w-4 text-warning" />
                  )}
                  <span className="text-sm font-display uppercase tracking-wider">{label}</span>
                </div>
                <span className={cn(
                  "text-sm font-mono font-bold",
                  item.score >= 90 ? "text-success" : 
                  item.score >= 70 ? "text-info" : 
                  item.score >= 50 ? "text-warning" : "text-destructive"
                )}>
                  {item.score}%
                </span>
              </div>
              <Progress 
                value={item.score} 
                className="h-1.5 bg-secondary"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ComplianceStatus;
